import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Widget } from '@src/shared/ui/components/Widget';
import { Skeleton } from '@src/shared/ui/components/Widget/components/Skeleton';
import { isEmpty } from 'lodash';
import React from 'react';

import { HorizontalBarChart } from './components/HorizontalBarChart';

/**
 * Widget: CountDistinctUntrustedCarrier
 *
 * @TODO Needs description.
 *
 * @param data
 * @returns {Element}
 * @constructor
 */
export function CountDistinctUntrustedCarrier({ data = {} }) {
  return (
    <ErrorHandler location="src/widgets/RiskRecords/CountDistinctUntrustedCarrier/CountDistinctUntrustedCarrier.jsx">
      {isEmpty(data) ? (
        <Skeleton />
      ) : (
        <Widget
          description={data?.description || ''}
          title={data?.name || 'RxBook1 - Count of distinct untrusted by carrier'}
        >
          {data?.defaultView === 'horizontalBarChart' && <HorizontalBarChart data={data?.data?.content} />}
        </Widget>
      )}
    </ErrorHandler>
  );
}
